<template>
    <div class="detail-data-wrapper mb-3">
        <h6 class="form-title">METODE PENCAIRAN</h6>
        <b-row>
            <b-col cols="12">
                <p class="mb-0">
                    {{ canEditMetodePencairan ? 'Saat ini:' : ''}} 
                    <strong>
                        {{ metodePencairan == TUNAI ? 'Tunai ': 'Non Tunai (Transfer)' }}
                    </strong>
                </p>
                <b-button
                    v-if="canEditMetodePencairan"
                    :disabled="isShowCancelApproval"
                    size="sm"
                    variant="pgiBtn"
                    class="mt-2"
                    @click="$bvModal.show('modal-change-metode-pencairan')"
                >
                    Ubah ke {{ metodePencairan == TUNAI ? 'Non Tunai (Transfer)' : 'Tunai' }}
                </b-button>
            </b-col>
            <template v-if="metodePencairan == NON_TUNAI">
                <b-col cols="12 mt-3">
                    <div v-if="dataGadai.statusGadai == 'Void' && stateDataApproval.isError"></div>
                    <b-alert v-else show variant="secondary" class="pb-4 mb-0">
                        <p class="mb-2 font-md font-semi-bold">
                            {{ IS_HAVE_PERMISSION_METODE_PENCAIRAN && !isStatusDisbursed ? 'Silakan pilih rekening tujuan:' : 'Rekening tujuan:' }} 
                        </p>
                        <div v-if="chooseRekening">
                            <div>
                                <i class="fa fa-credit-card mr-1"></i>
                                <strong>{{ chooseRekening.bankName }}</strong>
                            </div>
                            <p class="mb-0">{{ chooseRekening.noRekening }}</p>
                            <p class="mb-0">{{ chooseRekening.namePemilikRekening }}</p>
                        </div>
                        <div v-if="IS_HAVE_PERMISSION_METODE_PENCAIRAN && !isStatusDisbursed" class="d-flex flex-wrap mt-2 gap-2">
                            <b-button
                                @click="onShowModalListRekening"
                                :disabled="isShowCancelApproval"
                                size="sm"
                                variant="pgiBtn"
                            >
                                <i :class="chooseRekening ? 'fa fa-pencil mr-1' : 'fa fa-credit-card mr-1'"></i>
                                {{ chooseRekening ? 'Ubah Rekening Tujuan' : 'Pilih Rekening Tujuan' }}
                            </b-button>
                        </div>
                    </b-alert>
                </b-col>
                <b-col cols="12">
                    <b-row>
                        <b-col class="mt-3" cols="12" v-if="chooseRekening && IS_HAVE_PERMISSION_METODE_PENCAIRAN && !isStatusDisbursed">
                            <b-button
                                v-if="!isShowCancelApproval && !isStatusDisbursed"
                                @click="$bvModal.show('modal-request-approve')"
                                variant="pgiBtn"
                                name="requestApproval"
                            >
                                <i class="fa fa-paper-plane mr-2"></i> Ajukan Persetujuan
                            </b-button>
                            <b-button
                                v-if="isShowCancelApproval && !isStatusDisbursed"
                                @click="$bvModal.show('modal-cancel-approve')"
                                variant="danger"
                                name="cancelApproval"
                            >
                                <i class="fa fa-times mr-2"></i>
                                Batalkan Persetujuan
                            </b-button>
                        </b-col>
                        <b-col cols="12" v-if="showListApprovalDisburse">
                            <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-3">
                                <StateDetailHandler
                                    :isLoading="stateDataDisburse.isLoading"
                                    :isError="stateDataDisburse.isError"
                                    :lines="1"
                                    @retry="getDisburse"
                                >
                                    <h6 class="form-title mb-0" :class="allStatusClass">{{ allStatusLabel }}</h6>
                                </StateDetailHandler>
                                <b-button
                                    v-if="IS_HAVE_PERMISSION_METODE_PENCAIRAN && !isStatusDisbursed"
                                    :disabled="stateDataApproval.isLoading"
                                    @click="onRefresh"
                                    size="sm"
                                    variant="pgiBtn"
                                >
                                    Refresh Status Persetujuan {{ stateDataApproval.isLoading ? '...' : '' }}
                                </b-button>
                            </div>
                            <StateDetailHandler
                                :isLoading="stateDataApproval.isLoading"
                                :isError="stateDataApproval.isError"
                                :lines="10"
                                @retry="getApproval"
                            >
                                <b-list-group class="mt-3">
                                    <b-list-group-item v-for="item in dataApproval" :key="item.id">
                                        <h6 class="form-title text-uppercase">{{ item.role }}</h6>
                                        <b-row class="mb-2">
                                            <b-col cols="4" class="detail-data-label">Nama</b-col>
                                            <b-col>{{ item.approvalBy }}</b-col>
                                        </b-row>
                                        <b-row class="mb-2">
                                            <b-col cols="4" class="detail-data-label">Status</b-col>
                                            <b-col>
                                                <span class="status-box-md status-box-warning" v-if="item.statusApprovalId == STATUS_DISBURSEMENT_APPROVAL.PENDING">Pending</span>
                                                <span class="status-box-md status-box-success" v-if="item.statusApprovalId == STATUS_DISBURSEMENT_APPROVAL.APPROVED">Approved</span>
                                                <span class="status-box-md status-box-danger" v-if="item.statusApprovalId == STATUS_DISBURSEMENT_APPROVAL.REJECTED">Rejected</span>
                                                <span class="status-box-md status-box-danger" v-if="item.statusApprovalId == STATUS_DISBURSEMENT_APPROVAL.CANCELLED">Cancelled</span>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mb-2">
                                            <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                                            <b-col>{{ $helper.formatDateAndHour( item.updatedAt) }}</b-col>
                                        </b-row>
                                        <b-row class="mb-2">
                                            <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                                            <b-col>{{ item.reason || '-' }}</b-col>
                                        </b-row>
                                    </b-list-group-item>
                                </b-list-group>
                            </StateDetailHandler>
                        </b-col>
                    </b-row>
                </b-col>
            </template>
        </b-row>

        <ModalAddRekeningBank
            :stateOptionsBank="stateOptionsBank"
            :optionsBank="optionsBank"
            :userData="userData"
            @onSubmitAddRekening="onSubmitAddRekening"
        />
        <ModalListRekeningBank 
            :stateListRekening="stateListRekening"
            :dataListRekening="dataListRekening"
            :userData="userData"
            @onShowModalAddRekening="onShowModalAddRekening"
            @onSubmitInactiveRekening="onSubmitInactiveRekening"
            @onChooseRekening="onChooseRekening"
            :showChoose="true"
            :showAlert="true"
            :showAdd="true"
        />

        <ModalConfirm 
            id="modal-request-approve" 
            title="Konfirmasi Ajukan Persetujuan" 
            :isSubmitting="stateRequestApproval.isLoading"
            desc="Apakah Anda yakin ingin mengajukan persetujuan disbursement ini?" 
            @submit="onRequestApproval" 
        />

        <ModalConfirm 
            id="modal-cancel-approve" 
            title="Konfirmasi Batalkan Persetujuan" 
            :isSubmitting="stateCancelApproval.isLoading"
            desc="Apakah Anda yakin ingin membatalkan persetujuan disbursement ini?" 
            @submit="onCancelApproval" 
        />

        <ModalConfirm 
            id="modal-change-metode-pencairan" 
            title="Konfirmasi Pergantian Metode Pencairan" 
            :isSubmitting="stateChangeMetodePencairan.isLoading"
            desc="Apakah Anda yakin ingin mengganti metode pencairan ini?" 
            @submit="onChangeMetodePencairan" 
        />

        <ModalErrorAction
            modal-id="modal-error-request-approve"
            title="Error"
            :message="stateRequestApproval.error || ''"
            button-label="OK"
            dialog-class="modal-error-cetak-sbg-dialog"
        />

    </div>
</template>

<script>
import ModalAddRekeningBank from '@/components/modals/ModalAddRekeningBank';
import ModalListRekeningBank from '@/components/modals/ModalListRekeningBank';
import CONSTANTS from '@/constants'
import StateDetailHandler from '@/components/common/StateDetailHandler'
import ModalErrorAction from "@/components/modals/ModalErrorAction";

export default {
    name: 'form-metode-pencairan',
    props: {
        userData: {
            type: Object,
            required: true,
        },
        dataGadai: {
            type: Object,
            required: true,
        },
        hideListApprovalDisburse: { type: Boolean, default: false },
    },
    components: {
        ModalAddRekeningBank,
        ModalListRekeningBank,
        StateDetailHandler,
        ModalErrorAction,
    },
    data() {
        return {
            metodePencairan: this.dataGadai.disburseType,
            chooseRekening: null,
            dataListRekening: [],
            optionsBank: [],
            stateOptionsBank: {
                isLoading: false,
                error: null,
            },
            stateListRekening: {
                isLoading: false,
                error: null,
            },
            stateRequestApproval: {
                isLoading: false,
                error: null,
            },
            stateCancelApproval: {
                isLoading: false,
                error: null,
            },
            stateChangeMetodePencairan: {
                isLoading: false,
                error: null,
            },
            stateDataApproval: {
                isLoading: false,
                isError: false,
                error: null,
            },
            stateDataDisburse: {
                isLoading: false,
                isError: false,
                error: null,
            },
            statusAll: 0,
            isRequestApproval: false,
            dataApproval: []
        }
    },
    computed: {
        TUNAI() {
            return CONSTANTS.GADAI.METODE_PENCAIRAN.TUNAI
        },
        NON_TUNAI() {
            return CONSTANTS.GADAI.METODE_PENCAIRAN.NON_TUNAI
        },
        IS_HAVE_PERMISSION_METODE_PENCAIRAN() {
            const hasRole = this.$helper.hasPermissionMenuChildren('ABN');
            const isStatusBaru = this.dataGadai.statusGadai == 'Baru';
            const isCorrectPage = this.isTransaksiGadai;

            return hasRole && isStatusBaru && isCorrectPage;
        },
        STATUS_DISBURSEMENT_APPROVAL(){
            return CONSTANTS.GADAI.STATUS_DISBURSEMENT_APPROVAL
        },
        STATUS_DISBURSEMENT_GADAI(){
            return CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI
        },
        allStatusLabel() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            switch (this.statusAll) {
                case statusDisburse.WAIT_APPROVAL:
                    return 'Menunggu Persetujuan';
                case statusDisburse.APPROVED_ALL:
                    return 'Persetujuan Lengkap';
                case statusDisburse.DISBURSED:
                    return 'Berhasil Cair';
                case statusDisburse.DANA_DITANGGUHKAN:
                    return 'Dana Ditangguhkan';
                case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
                    return 'Gagal Cair';
                case statusDisburse.CEK_IT:
                    return 'Mohon Hubungi IT';
                case statusDisburse.CANCELLED:
                    return 'Dibatalkan';
                case statusDisburse.REJECTED:
                    return 'Ditolak';
                default:
                    return '-';
            }
        },
        allStatusClass() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            switch (this.statusAll) {
                case statusDisburse.WAIT_APPROVAL:
                    return 'status-wait';
                case statusDisburse.APPROVED_ALL:
                    return 'status-approved';
                case statusDisburse.DISBURSED:
                    return 'status-disbursed';
                case statusDisburse.DANA_DITANGGUHKAN:
                    return 'status-wait';
                case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
                    return 'status-rejected';
                case statusDisburse.CEK_IT:
                    return 'status-rejected';
                case statusDisburse.CANCELLED:
                    return 'status-cancelled';
                case statusDisburse.REJECTED:
                    return 'status-rejected';
                default:
                    return '';
            }
        },
        isShowCancelApproval() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            const isWaitingApproval = this.statusAll === statusDisburse.WAIT_APPROVAL;
            const isApprovedAll = this.statusAll === statusDisburse.APPROVED_ALL;

            if ((isWaitingApproval || isApprovedAll) && this.isRequestApproval) {
                return true;
            }

            return false;
        },
        isStatusDisbursed() {
            const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
            if (this.statusAll == statusDisburse.DISBURSED) {
                return true;
            }

            return false
        },
        showListApprovalDisburse() {
            return this.isRequestApproval && !this.hideListApprovalDisburse
        },
        canEditMetodePencairan() {
            if (this.IS_HAVE_PERMISSION_METODE_PENCAIRAN &&
                !this.isStatusDisbursed &&
                this.dataGadai.statusGadai == 'Baru'
            ) {
                return true
            }

            return false
        },
        isTransaksiGadai() {
            const isCorrectPage = this.$route.path.includes('kasir/transaksi-gadai');
            return isCorrectPage
        }
    },
    methods: {
        init() {
            this.getApproval()
        },
        onShowModalAddRekening() {
            this.$bvModal.show("modal-add-rekening-bank")
            this.getOptionsBank()
        },
        onShowModalListRekening() {
            this.$bvModal.show("modal-list-rekening-bank")
            this.getListRekening()
        },
        onSubmitAddRekening() {
            this.onShowModalListRekening()
        },
        onSubmitInactiveRekening(id) {
            this.onShowModalListRekening()
            if (this.chooseRekening && this.chooseRekening.id == id) {
                this.chooseRekening = null
            }
        },
        onChooseRekening(data) {
            this.$bvModal.hide("modal-list-rekening-bank")
            this.chooseRekening = data
        },
        getOptionsBank() {
            this.stateOptionsBank.isLoading = true;
            this.stateOptionsBank.error = null;
            this.$axios.get('nasabah/list-bank')
                .then((response) => {
                    this.optionsBank = response.data
                })
                .catch((error) => {
                    const errorMessage = error.response.data.reason || error.response.data.error;
                    this.stateOptionsBank.error = errorMessage;
                })
                .finally(() => {
                    this.stateOptionsBank.isLoading = false;
                })
        },
        getListRekening() {
            this.stateListRekening.isLoading = true;
            this.stateListRekening.error = null;
            const id = this.userData.nasabahId
            this.$axios.get(`nasabah/list-bank/${id}`)
                .then((response) => {
                    this.dataListRekening = response.data
                })
                .catch((error) => {
                    const errorMessage = error.response.data.reason || error.response.data.error;
                    this.stateListRekening.error = errorMessage;
                })
                .finally(() => {
                    this.stateListRekening.isLoading = false;
                })
        },
        onRequestApproval() {
            const payload = {
                gadaiId: this.dataGadai.id,
                nasabahBankAccountId: this.chooseRekening.id,
            }

            this.stateRequestApproval.isLoading = true;
            this.stateRequestApproval.error = null;

            this.$axios.post('gadai-disburse/', {}, { params: payload }).then(response => {
                this.isRequestApproval = true;
                this.$emit('onSafeRetryReset')
                this.$helper.toastSucc(this, response.data.name);
                this.$bvModal.hide('modal-request-approve')
                this.getApproval();
            }).catch(error => {
                const message = this.$helper.parseError(this, error, '', false)
                this.stateRequestApproval.error = message;
                this.showModalErrorRequestApprove()
            }).finally(() => {
                this.stateRequestApproval.isLoading = false;
            })
        },
        onCancelApproval() {
            const gadaiId = this.dataGadai.id;

            this.stateCancelApproval.isLoading = true;
            this.stateCancelApproval.error = null;

            this.$axios.post(`gadai-disburse/cancel-disbursement/${gadaiId}`).then(response => {
                this.$helper.toastSucc(this, response.data.name);
                this.getApproval();
                this.$bvModal.hide('modal-cancel-approve');
            }).catch(error => {
                this.$helper.parseError(this, error)
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateCancelApproval.error = errorMessage;
            }).finally(() => {
                this.stateCancelApproval.isLoading = false;
            })
        },
        onChangeMetodePencairan() {
            const payload = {
                gadaiId: this.dataGadai.id,
            }

            if (this.metodePencairan == this.TUNAI && this.dataGadai.wajibTunai === true) {
                this.$helper.toastErr(this, 'Percobaan disbursement sudah gagal 3 kali. Pencairan tidak bisa diubah ke non tunai.')
                return
            }

            this.stateChangeMetodePencairan.isLoading = true;
            this.stateChangeMetodePencairan.error = null;
            let url = ''

            if (this.metodePencairan == this.TUNAI) {
                url = 'gadai-disburse/switch-to-noncash'
            } else {
                url = 'gadai-disburse/switch-to-cash'
            }

            const switchRequest = () => this.$axios.post(url, {}, { params: payload })
            const shouldCancelDisbursement = this.metodePencairan != this.TUNAI
                && this.dataGadai.wajibTunai === true

            const request = shouldCancelDisbursement
                ? this.$axios.post(`gadai-disburse/cancel-disbursement/${this.dataGadai.id}`)
                    .then(switchRequest)
                : switchRequest()

            request.then(response => {
                this.$bvModal.hide('modal-change-metode-pencairan')
                if (this.metodePencairan == this.TUNAI) {
                    this.metodePencairan = this.NON_TUNAI
                    this.chooseRekening = null
                    this.dataApproval = [];
                    this.isRequestApproval = false;
                } else {
                    this.$emit('onFeeBank', null)
                    this.$emit('onStatusDisbursed', null)
                    this.$emit('onSafeRetryReset')
                    this.metodePencairan = this.TUNAI
                }
            }).catch(error => {
                this.$helper.parseError(this, error)
                const errorMessage = error.response.data.reason || error.response.data.error;
                this.stateChangeMetodePencairan.error = errorMessage;
            }).finally(() => {
                this.stateChangeMetodePencairan.isLoading = false;
            })
        },
        getApproval() {
            this.stateDataApproval.isLoading = true;
            this.stateDataApproval.isError = false;
            this.stateDataApproval.error = null;
            this.$axios.get(`gadai-disburse/check-approval/${this.dataGadai.id}`)
                .then((response) => {
                    if (response.data.length > 0) {
                        this.dataApproval = response.data;
                        this.isRequestApproval = true;
                        this.getDisburse();
                    }
                })
                .catch((error) => {
                    this.stateDataApproval.isError = true;
                    const errorMessage = error.response.data.reason || error.response.data.error;
                    this.stateDataApproval.error = errorMessage;
                })
                .finally(() => {
                    this.stateDataApproval.isLoading = false;
                })
        },
        getDisburse() {
            this.stateDataDisburse.isLoading = true;
            this.stateDataDisburse.isError = false;
            this.stateDataDisburse.error = null;
            this.$axios.get(`gadai-disburse/disburse-status/${this.dataGadai.id}`)
                .then((response) => {
                    const data = response.data;
                    if (data) {
                        this.chooseRekening = {
                            id: data.nasabahBankAccountId,
                            noRekening: data.nasabahBankNumber,
                            bankName: data.nasabahBankName,
                            nasabahName: data.nasabahName,
                            namePemilikRekening: data.nasabahPemilikRekeningName,
                        }
                        this.statusAll = data.status
                        this.$emit('onFeeBank', data.fee)
                        this.$emit('onStatusDisbursed', data.status)
                        this.prevRekening = this.chooseRekening
                    }
                })
                .catch((error) => {
                    this.stateDataDisburse.isError = true;
                    const errorMessage = error.response.data.reason || error.response.data.error;
                    this.stateDataDisburse.error = errorMessage;
                })
                .finally(() => {
                    this.stateDataDisburse.isLoading = false;
                })
        },
        showModalErrorRequestApprove() {
            this.$bvModal.hide("modal-request-approve");
            this.$bvModal.show("modal-error-request-approve");
        },
        onRefresh() {
            this.getApproval()
        },
    },
    created() {
        this.init();
    }
}
</script>
